<template>

  <div class="col-lg-12  mb-4">
      <v-card flat>
        <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
      </v-card>
    </div>
  </template>
  
  <script>
  import apexchart from 'vue-apexcharts'
  
  export default {
    name: 'BarChart',
    components: {
      apexchart
    },
    mounted(){
      this.getSeriesFromData();
    },
    data() {
      return {
            series: [],
            chartOptions: {
              chart: {
              type: 'bar',
              height: 350,
              toolbar: {
                  show: true,
                  tools: {
                    download: false
                  }
                }
              },
              plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '70%',
                endingShape: 'rounded'
                },
              },
              colors: ['#8B5AF4', '#43D9AF', '#FF7299', '#848484'],
              dataLabels: {
                enabled: true,
              },
              grid: {
                borderColor: '#e7e7e7',
                row: {
                  colors: ['transparent'], // takes an array which will be repeated on columns
                  opacity: 0.5
                },
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
              },
              markers: {
                size: 1
              },
              xaxis: {
                categories: [
                'Trifft überhaupt nicht zu',
                'Trifft nicht zu',
                'Trifft eher nicht zu',
                'Trifft eher zu',
                'Trifft zu',
                'Trifft voll und ganz zu',                
                ],
              },
              yaxis: {
                min: 0,
                max: this.getMaxFromData(),
                tickAmount: this.getMaxFromData()
              },
              legend: {
                position: 'bottom',
                floating: false,
              }
            }
          }
        },
    props: {
      data:{
          type: Object
      },
    },
    watch:{
      data(){
        this.getSeriesFromData();
      }
    },
    methods:{
      getMaxFromData(){
        let values = this.data.evalData.map(ev => Object.values(ev.scores)).flat();
        return Math.max(...values) + 1;
      },
      getCategories(){
        return this.data.map(e => new Date(e.timestamp).toLocaleDateString('de-DE'));
      },
      getSeriesFromData(){
        this.series = [];
        this.data.evalData.forEach(elem => {
          let chartData = elem.inverted ? Object.values(elem.scores).reverse():Object.values(elem.scores);
          this.series.push({
          name: new Date(elem.timestamp).toLocaleDateString('de-DE'),
          data: chartData
        });
        })
      }
    } 
  }
  </script>
  
  